module.exports = __webpack_public_path__ + "static/media/avenir-medium.85db860a.woff2";